import dedent from 'ts-dedent'
import {
  ColumnDataType,
  Provider,
  QueryAndOutputs,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType,
  WorkflowComponentParameterMode
} from '../types'
import { SINGLE_OUTPUT_NAME, SingleOutputWorkflowComponent } from './common/singleoutputcomponent'

class CronbachAlphaCoefficient extends SingleOutputWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.cronbachalphacoefficient',
        group: 'Statistics',
        title: 'Cronbach Alpha Coefficient',
        description: `
        This component computes the Cronbach Alpha Coefficient,
        which can be used to measure internal consistency of different variables.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'variablecolumns',
          type: WorkflowComponentParamType.Column,
          title: 'Input variables',
          parent: 'source',
          mode: WorkflowComponentParameterMode.Multiple,
          dataType: [ColumnDataType.Number]
        }
      ]
    )
  }

  async getCode({
    workflow,
    params,
    connection,
    envVars,
    componentName,
    codeType
  }: WorkflowComponentCodeParams): Promise<QueryAndOutputs | null> {
    const preparedParams = this._prepareParameters(params)
    const tablename = connection.getOutputTableName(workflow.id, componentName, params, SINGLE_OUTPUT_NAME, codeType)
    const columns = preparedParams.variablecolumns as Array<string>
    const query = dedent`
          CALL ${connection.quoteName(envVars.analyticsToolboxDataset as string)}.CRONBACH_ALPHA_COEFFICIENT(
            'SELECT ${columns.join(', ')} FROM ${connection.quoteName(preparedParams.source as string)}',
            '${tablename}');`

    return {
      outputs: { result: tablename },
      query
    }
  }

  requiredAnalyticsToolboxVersion(provider: Provider): string | null {
    switch (provider) {
      case Provider.Snowflake:
        return '1.8.0'
      default:
        return '1.0.0'
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getVersion(provider: Provider): string {
    return '1.0.0'
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema(): TableSchema {
    return [
      {
        name: 'cronbach_alpha_coef',
        type: ColumnDataType.Number
      },
      {
        name: 'k',
        type: ColumnDataType.Number
      },
      {
        name: 'mean_var',
        type: ColumnDataType.Number
      },
      {
        name: 'mean_cov',
        type: ColumnDataType.Number
      }
    ]
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Snowflake]
  }
}

export { CronbachAlphaCoefficient }
